export default {
  state: {
    general: {},
    top_section: {},
    bottom_section: {}
  },
  mutations: {
    SET_INTERFACE_GENERAL(state, payload) {
      state.general = payload
    },
    SET_INTERFACE_TOP_SECTION(state, payload) {
      state.top_section = payload
    },
    SET_INTERFACE_BOTTOM_SECTION(state, payload) {
      state.bottom_section = payload
    }
  }
}
